import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getRolledOverLoans = async ({ parent_rollover_loan_reference }) => {
  const data = await getData(
    `${ajaxEndpoints.ROLLED_OVER_LOANS}?parent_rollover_loan_reference=${parent_rollover_loan_reference}`
  );
  return data;
};

export default function useRolledOverLoans({ parent_rollover_loan_reference }) {
  return useQuery(
    [{ parent_rollover_loan_reference }, "getRolledOverLoans"],
    getRolledOverLoans,
    { enabled: parent_rollover_loan_reference ? true : false }
  );
}
